import { render, staticRenderFns } from "./SurfaceForm.vue?vue&type=template&id=731a6e56&"
import script from "./SurfaceForm.vue?vue&type=script&lang=js&"
export * from "./SurfaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports